<template>
    <div class="visual-infrastructure">
        <svg
            class="visual-infrastructure__svg-canvas"
            viewBox="0 0 1920 1080"
            preserveAspectRatio="xMidYMid slice"
        >
            <template v-for="item in infrastructure">
                <svg
                    :x="[item.left ? item.left : 0]"
                    :y="[item.top ? item.top : 0]"
                    :key=item.id
                    ref="anchor"
                ></svg>
            </template>
        </svg>

        <template v-for="(item, index) in infrastructure">
            <img
                :class="`visual-infrastructure__item visual-infrastructure__item-${index}`"
                :id=item.id
                :key=item.id
                :src=item.icon
                :alt=item.name
                :style="{ top: item.reposition.top, left: item.reposition.left}"
                ref="infrastructure"
            >
        </template>
    </div>
</template>

<style lang='scss'>
    @import "./Infrastructure.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import reposition from '../../helpers/reposition';

const observer = new Observer();

export default {
    computed: {
        ...mapGetters({
            infrastructure: 'GET_INFRASTRUCTURE',
            rotate        : 'GET_ROTATE'
        })
    },

    watch: {
        rotate() {
            this.$nextTick(() => {
                this.position();
            });
        }
    },

    mounted() {
        this.position();

        window.addEventListener('resize', this.position);
    },

    methods: {
        ...mapActions(['changePosition']),

        /**
         * Метод позиционирует инфраструктуру согласно координатам svg-якорей.
         */
        position() {
            if (this.infrastructure && this.infrastructure.length) {
                const coords = reposition(this.$refs.anchor);

                this.changePosition({
                    type: 'infrastructure',
                    coords
                });
            }
        },

        mouseOverHandler(id, event) {
            observer.publish('mouseoverTooltip', {
                id,
                event,
                elements: this.infrastructure,
                type    : 'infrastructure',
                modify  : 'visual-tooltip_theme_infrastructure'
            });
        },

        mouseMoveHandler(event) {
            observer.publish('mousemoveTooltip', event);
        },

        mouseLeaveHandler() {
            observer.publish('mouseleaveTooltip');
        }
    },

    destroyed() {
        window.removeEventListener('resize', this.position);
    }
};
</script>
